export function TrophyOverlay() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#09090b] px-6">
      <div className="relative w-full max-w-sm">
        <div
          aria-hidden="true"
          className="trophy-glow aurora-orb pointer-events-none absolute inset-x-[18%] inset-y-[18%] rounded-full blur-3xl"
        />
        <img
          src="/trophytopia-logo.png"
          alt=""
          width={679}
          height={661}
          className="trophy-mark logo-glow relative mx-auto h-auto w-full max-w-xs sm:max-w-sm"
        />
      </div>
    </div>
  );
}

export function createUnlockAudio() {
  const AudioContextCtor =
    window.AudioContext ||
    (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;

  if (!AudioContextCtor) {
    return { play() {}, cancel() {} };
  }

  const context = new AudioContextCtor();
  void context.resume();
  const ready = fetch("/trophy-unlock.wav")
    .then((response) => response.arrayBuffer())
    .then((buffer) => context.decodeAudioData(buffer));

  return {
    play() {
      void ready.then((buffer) => {
        const source = context.createBufferSource();
        const gain = context.createGain();
        gain.gain.value = 0.55;
        source.buffer = buffer;
        source.connect(gain);
        gain.connect(context.destination);
        source.start();
      });
    },
    cancel() {
      void context.close();
    },
  };
}
